var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { parseError } from "@ane/core/lib/utils/ErrorUtils";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
class WPSResource extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.wps, "", parseError);
  }
  getWorkspaceMetaData(workspaceId) {
    return __async(this, null, function* () {
      let address = `/workspace/${workspaceId}/proxy-metadata?api-version=1.0-preview.1`;
      const result = yield this._get(address);
      return result;
    });
  }
  updateWorkspaceProxyStatus(data) {
    return __async(this, null, function* () {
      let address = `/workspace/${data.workspaceId}/proxy-config/proxy-enabled?api-version=1.0-preview.1`;
      const result = yield this._put(data, address);
      return result;
    });
  }
  getWorkspaceProxyStatus(workspaceId) {
    return __async(this, null, function* () {
      let address = `/workspace/${workspaceId}/proxy-config/proxy-enabled?api-version=1.0-preview.1`;
      const result = yield this._get(address);
      return result;
    });
  }
  getWorkspaceServicePrincipals(workspaceId, identityType) {
    return __async(this, null, function* () {
      let address = `/workspace/${workspaceId}/service-principal?identityType=${identityType}&api-version=1.0-preview.1`;
      const result = yield this._get(address);
      return result;
    });
  }
  getSecurityGroups(workspaceId, search) {
    return __async(this, null, function* () {
      let address = `/workspace/${workspaceId}/security-group?search=${search}&api-version=1.0-preview.1`;
      const result = yield this._get(address);
      return result;
    });
  }
  getUAAAccess(workspaceId) {
    return __async(this, null, function* () {
      let address = `/workspace/${workspaceId}/uaa-access?api-version=1.0-preview.1`;
      const result = yield this._get(address);
      return result;
    });
  }
  putWorkspaceServicePrincipals(workspaceId, servicePrincipalId, data, identityType) {
    return __async(this, null, function* () {
      let address = `/workspace/${workspaceId}/proxy-config/service-principal/${servicePrincipalId}?identityType=${identityType}&api-version=1.0-preview.1`;
      const result = yield this._put(data, address);
      return result;
    });
  }
  deleteWorkspaceServicePrincipal(workspaceId, servicePrincipalId, identityType) {
    return __async(this, null, function* () {
      let address = `/workspace/${workspaceId}/proxy-config/service-principal/${servicePrincipalId}?identityType=${identityType}&api-version=1.0-preview.1`;
      const result = yield this._delete(address);
      return result;
    });
  }
  putWorkspaceSecurityGroups(workspaceId, data) {
    return __async(this, null, function* () {
      let address = `/workspace/${workspaceId}/proxy-config/security-group?api-version=1.0-preview.1`;
      const result = yield this._put(data, address);
      return result;
    });
  }
  deleteWorkspaceSecurityGroup(workspaceId, securityGroupId, experimentRole) {
    return __async(this, null, function* () {
      let address = `/workspace/${workspaceId}/proxy-config/security-group/${securityGroupId}/experiment-role/${experimentRole}?api-version=1.0-preview.1`;
      const result = yield this._delete(address);
      return result;
    });
  }
}
const WPSResource$1 = new WPSResource();
export {
  WPSResource$1 as default
};
//# sourceMappingURL=WPS.resource.js.map
